import React, { Component } from "react";

export default class Cinemagraph extends Component {
	
	render () {
		
		
		let src 	= this.props.src;
		
		if (this.props.width) {
			
			let width 	= this.props.width;
			let height 	= this.props.height;
						    
		    return (
			    					
				<div className="c-media" style={{paddingTop:((height / width) * 100) + '%'}} dangerouslySetInnerHTML={ {__html:'<video src="' + src + '" autoplay loop muted playsinline></video>'}}></div>
			    
			)
			
		} else {
			return (
			    					
				<div className="c-media" dangerouslySetInnerHTML={ {__html:'<video src="' + src + '" autoplay loop muted playsinline></video>'}}></div>
			    
			)
		}
			
	}
}
